import { displayEventsType } from "../../../app-admin/features/workflow/workflowSlice";

export const eventActions: string[] = ["CreateBusinessCase", "CreateVersion"];
export const eventTypeList: displayEventsType[] = ["OnStart", "OnComplete"];
